import { Provider } from '../types/Provider';
import { Tag } from '../types/Tag';
import { CategoryModel } from './CategoryModel';

export class MetadataModel {
  private _categories: CategoryModel[] = [];
  private _tags: Tag[] = [];
  private _providers: Provider[] = [];

  constructor(
    categories: CategoryModel[],
    providers: Provider[],
    tags: Tag[] = []
  ) {
    this._categories = categories;
    this._providers = providers;
    this._tags = tags;
  }

  public static is(value: any) {
    return (
      value._categories !== undefined &&
      value._providers !== undefined &&
      value._tags !== undefined
    );
  }

  public static from(data: MetadataModel) {
    return new MetadataModel(
      data._categories.map((c) => CategoryModel.from(c)),
      data._providers,
      data._tags
    );
  }

  get providers() {
    return this._providers;
  }

  getProviderById(id: string) {
    return this._providers.find((p) => p.id === id);
  }

  getAllCategories() {
    return this._categories;
  }

  getCategory(category: string) {
    return this._categories.find(
      (c) =>
        c.slug === category ||
        c.id === category ||
        c.displayName.includes(category)
    )!;
  }

  getCategoryById(id: string) {
    return this._categories.find((c) => c.id === id)!;
  }

  getCategoryBySlug(slug: string) {
    return this._categories.find(
      (c) => c.slug.toLowerCase() === slug.toLowerCase()
    )!;
  }

  getColor(category: string) {
    return this.getCategory(category).color;
  }

  get tags() {
    return this._tags;
  }
}
